<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@font-face {
  font-family: "myFont";
  /* src: url("../../assets/fonts/DIN-Bold.woff") format("woff"),
    url("../../assets/fonts/FZLTZCHJW.TTF") format("truetype"); */
  src: url("//img.58cdn.com.cn/webfonts/resume/FZLTZCHJW.TTF")
    format("truetype");
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: myFont, PingFang SC, Microsoft YaHei, 微软雅黑, MicrosoftJhengHei,
    华文细黑, STHeiti, MingLiu, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  height: 100%;
}

body {
  background: #a1e6cd;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue